import axios from "axios";
import { store, persistor } from "src/store";

const URL = process.env.REACT_APP_API_URL;

export const AxiosInstance = axios.create({
  baseURL: URL,
  withCredentials: false,
  timeout: 100000,
});

AxiosInstance.interceptors.request.use(
  (config) => {
    // ✅ Usa el token directo del store de Redux (misma fuente que useSelector)
    const token = store.getState().token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

AxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const { expired, duplicated } = error.response.data || {};

      if (expired) {
        // Token expirado → mostrar modal de renovación
        window.dispatchEvent(new CustomEvent("token-expired"));
      } else {
        // Token inválido o sesión duplicada → logout directo
        if (duplicated) {
          window.dispatchEvent(new CustomEvent("session-duplicated"));
        }

        store.dispatch({
          type: "set",
          authUser: false,
          dataUser: [],
          token: null,
          tokenExpiresIn: "",
        });

        persistor.purge();
        window.location.replace("/#/login");
      }
    }

    return Promise.reject(error);
  },
);
